<template>
  <div class="no-internet-alert">
    <icon-no-internet width="50"
                      height="50"
                      class="icon"
                      iconColor="#3e3a3b" />
    <div>
      {{ $t("noInternetConnection") }}
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang='scss' scoped>
  .no-internet-alert {
    width: 500px;
    height: 60px;
    margin-top: 90px;
    color: #3e3a3b;
    background: #EBEAEA;

    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    left: calc(50% - 250px);
    z-index: 9999;

    border-radius: 5px;
    box-shadow: 0 1px 5px rgba(0,0,0,.65);

    .icon {
      margin-right: 20px;
    }
  }
</style>